import _ from 'underscore';

import {
  generateId,
  generateSectionWithComponent,
} from '@bingads-webui-campaign-react/smart-component-util';

import { TemplateComponentListMapping, SmartPageTemplate } from '../consts';

export const getDefaultSiteTemplate = () => {
  const siteStructureTemplate = {
    dataSource: {},
    pages: [{
      id: generateId('pge'),
      components: [],
    }],
    theme: { themeId: 'theme_gray' },
    websiteSourceData: {},
  };

  _.each(TemplateComponentListMapping[SmartPageTemplate.Default], (item) => {
    siteStructureTemplate.pages[0].components.push(...generateSectionWithComponent({
      componentType: item.type,
      sectionIndex: item.order,
    }));
  });

  return siteStructureTemplate;
};
